import { Lightning } from "@phosphor-icons/react";
import { formatDateIT } from "@/lib/formatDate";
import { OverviewCard, OverviewEmpty } from "./Card";

/**
 * Widget #5 — Barra di avanzamento della fase corrente.
 * Stessa logica della visualizzazione cliente (ClientProgressDashboard):
 * fase con status "in_corso" + date di inizio/fine valide.
 */
export function PhaseProgressWidget({ phases }) {
  const activePhase = phases.find((p) => p.status === "in_corso");
  let info = null;
  if (activePhase?.start_date && activePhase?.end_date) {
    const start = new Date(activePhase.start_date);
    const end = new Date(activePhase.end_date);
    const today = new Date();
    const totalDays = Math.max((end - start) / 86400000, 1);
    const elapsed = Math.max(Math.min((today - start) / 86400000, totalDays), 0);
    const pct = Math.round((elapsed / totalDays) * 100);
    const totalWeeks = Math.ceil(totalDays / 7);
    const currentWeek = Math.min(Math.ceil(elapsed / 7), totalWeeks);
    info = {
      title: activePhase.title,
      pct,
      currentWeek,
      totalWeeks,
      start: activePhase.start_date,
      end: activePhase.end_date,
    };
  }

  return (
    <OverviewCard
      title="Fase in corso"
      icon={Lightning}
      iconColor="text-[#D4FF00]"
      testId="overview-phase-progress"
    >
      {!info ? (
        <OverviewEmpty message="Nessuna fase attiva con date impostate." />
      ) : (
        <div className="space-y-3">
          <div className="flex items-center justify-between">
            <p
              className="text-base font-bold text-white tracking-tight"
              style={{ fontFamily: "Barlow Condensed, sans-serif" }}
            >
              {info.title.toUpperCase()}
            </p>
            <span className="text-xs text-zinc-500">
              Sett. {info.currentWeek}/{info.totalWeeks}
            </span>
          </div>
          <div className="relative h-2 rounded-full bg-[#1A1A1A] overflow-hidden">
            <div
              className="absolute inset-y-0 left-0 bg-gradient-to-r from-[#007AFF] to-[#D4FF00] rounded-full transition-all"
              style={{ width: `${info.pct}%` }}
            />
          </div>
          <div className="flex items-center justify-between text-[11px] text-zinc-500">
            <span>{formatDateIT(info.start)}</span>
            <span className="text-[#D4FF00] font-semibold">{info.pct}%</span>
            <span>{formatDateIT(info.end)}</span>
          </div>
        </div>
      )}
    </OverviewCard>
  );
}
